import moment from "moment";

export const formatDate = (dateString) => dateString ? moment(dateString).format('DD/MMMM/YYYY') : '';